export default __webpack_public_path__ + "static/media/search_icon.8f087342.svg";